<template>
  <div>
    <Fancybox :options="{
      Carousel: {
        infinite: true,
      },
    }">

      <div class="grid grid-cols-product-images gap-s40 mt-s20">
        <div class="grid content-start gap-s25 m_1200:gap-s40">
          <a v-for="(item, index) in showFirstThree" :key="index" data-fancybox="gallery" :href="item">
            <div class="grid grid-cols-1 grid-rows-1" v-if="index === 2">
              <img :src="getResized(item)" width="120" height="182" class="grid-area" :alt="alt"/>
              <div v-if="showRest.length >= 1" class="w-full h-full bg-black/30 grid-area grid place-items-center">
                <p class="text-white text-center text-t20">+{{ showRest.length }}</p>
              </div>
            </div>

            <img v-else :src="getResized(item)" width="120" height="182" :alt="alt"/>
          </a>
        </div>

        <div class="relative">
          <a data-fancybox="gallery" :href="thumbnail">
            <img :src="thumbnailLarge" width="420" height="637" :alt="alt"/>
          </a>

          <div class="absolute text-center text-white -top-s5 -right-s5 w-fit grid gap-s5">
            <div v-for="(item, index) in stickers" :key="index" class="py-s3 text-t12 uppercase rounded-md w-s140"
              :class="'sticker-' + item.sticker_color">
              {{ item.title }}</div>
          </div>
        </div>

        <!-- Hidden images just for fancybox slider element -->
        <div class="hidden">
          <a v-for="(item, index) in showRest" :key="index" data-fancybox="gallery" :href="item">
            <img :src="item" width="120" height="182" :alt="alt"/>
          </a>
        </div>

      </div>
    </Fancybox>
  </div>
</template>

<script>
import Fancybox from './Fancybox.vue';

export default {
  name: "ProductImages",
  components: {
    Fancybox,
  },
  props: [
      'thumbnail',
      'thumbnailLarge',
      'gallery',
      'stickers',
	    'alt'
  ],

  computed: {

    /**
     * Get first three images of gallery.
     */
    showFirstThree: function()
    {
      return this.gallery.slice(0,3);
    },

    /**
     * Get the rest of images.
     */
    showRest() {
      return this.gallery.slice(3);
    },
  },
	methods: {

		/**
		 * Create link for desktop gallery images.
		 *
		 * @param item
		 * @returns {string}
		 */
		getResized(item){
			const words = item.split('/images/');
			let middle = '/resized/small/images/'

			return words[0] + middle + words[1];
		}
	}
};
</script>
